<template>
  <b-card class="shadow-sm">
    <b-card-body>
      <b-card-title class="mb-2 pl-6 pr-6 pt-6">
        <div>
          <b-icon icon="currency-dollar" variant="primary" class="mr-2" />
          <span>Margem de lucro</span>
        </div>

        <!-- Filtro de período -->
        <FiltroPeriodo
          class="mt-4"
          :value="periodo"
          default-label="Hoje"
          :auto-apply-on-mount="!ignoreInitialApply"
          @apply="onApplyPeriodo"
        />
      </b-card-title>

      <div class="pl-6 pb-4">
        <!-- LOADING -->
        <div v-if="loading" class="display-4">
          <b-skeleton width="40%" height="36px" />
        </div>

        <!-- CONTEÚDO -->
        <div v-else>
          <h2 class="display-4 text-primary mb-0 font-weight-bold">
            {{ formatPercent(margemNumber) }}
          </h2>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import FiltroPeriodo from "./FiltroPeriodo.vue";

export default {
  name: "MargemLucro",
  components: { FiltroPeriodo },
  props: {
    // valor da margem (ex.: 0.4 ou 40)
    margemLucro: { type: [Number, String], default: 0 },

    // período atual (opcional): { inicio: 'YYYY-MM-DD', fim: 'YYYY-MM-DD' } ou null
    periodo: { type: Object, default: null },

    // estado de carregamento
    loading: { type: Boolean, default: false },

    // se true, NÃO dispara apply no mount do filtro (mantém quieto no boot)
    ignoreInitialApply: { type: Boolean, default: true },

    // opcional: mensagem de erro (se quiser exibir algo custom)
    error: { type: String, default: null },
  },
  computed: {
    margemNumber() {
      const n = this.margemLucro.margemPercent;
      return Number.isFinite(n) ? n : 0;
    },
  },
  methods: {
    onApplyPeriodo({ inicio, fim }) {
      // repassa para o pai exatamente como o TicketMedio faz
      this.$emit("change-periodo", { inicio, fim });
    },
    formatPercent(v) {
      if (v === null || v === undefined || v === "") return "0%";
      return `${String(v).replace(".", ",")}%`;
    },
  },
};
</script>

<style scoped>
.display-4 {
  line-height: 1.1;
}
</style>
